import React, { useState } from 'react';
import styles from './ChallengesTable.module.scss';
import { GreenButton } from '../../../Shared/GreenButton/GreenButton';
import { PopupConfirmDialog } from '../../../Shared/PopupConfirmDialog/PopupConfirmDialog';
import { IChallengeTableProps } from '../../../../types/IChallenge';
import { useApplyAction } from '../../../../hooks/useApplyAction';
import { ChallengeStatusBadge } from '../../../Shared/ChallengeStatusBadge/ChallengeStatusBadge';

const tableHeader: string[] = ['ID', 'GAME', 'PLATFORM', 'STATUS', 'ENTRY FEE', 'PARTICIPANTS', 'RESULT'];

export const ChallengesTable = ({ data, actions, refetch }: IChallengeTableProps): React.JSX.Element => {
    const { mutate: applyAction } = useApplyAction();
    const [changeStatusId, setChangeStatusId] = useState('');

    const onChangeStatus = (status: string) => {
        if (status) {
            applyAction(
                {
                    challengeId: changeStatusId,
                    action: status,
                },
                {
                    onSuccess() {
                        onCloseModal();
                        refetch();
                    },
                    onError(e) {
                        console.log('e', e.response);
                        alert(JSON.stringify(e?.response?.data ?? '{}') ?? e);
                    },
                }
            );
        }
    };

    const onCloseModal = () => {
        setChangeStatusId('');
    };

    if (!data) return <></>;

    return (
        <div className={styles.container}>
            <PopupConfirmDialog title="Select action" description="" show={!!changeStatusId} onClose={onCloseModal}>
                {actions?.map((action) => (
                    <div key={action} className={styles.action}>
                        <GreenButton
                            mini
                            outline
                            onClick={() => {
                                onChangeStatus(action);
                                console.log('action', action);
                            }}
                        >
                            {action}
                        </GreenButton>
                    </div>
                ))}
            </PopupConfirmDialog>

            <table className={styles.table}>
                <thead>
                    <tr>
                        {tableHeader.map((headerElement) => (
                            <td key={headerElement}>{headerElement}</td>
                        ))}
                        <td></td>
                    </tr>
                </thead>
                <tbody>
                    {data.map((challenge, idx) => (
                        <tr key={challenge.id} className={idx % 2 ? '' : styles.grayColl}>
                            <td>{challenge.id}</td>
                            <td>{challenge.gameVersion}</td>
                            <td>{challenge.platform}</td>
                            <td>
                                <ChallengeStatusBadge status={challenge.status} />
                            </td>
                            <td>{challenge.bet}</td>
                            <td>
                                <div className={styles.row}>
                                    <div className={styles.name}>
                                        {challenge.participants.map((user) => user.nickname).join(' VS ')}
                                    </div>
                                </div>
                            </td>
                            <td>
                                {challenge.results
                                    .map((challengeResult) => `${challengeResult.userId} (${challengeResult.result})`)
                                    .join(' ')}
                            </td>
                            <td>
                                <div className={styles.row}>
                                    <GreenButton
                                        noMargin
                                        mini
                                        onClick={() => {
                                            setChangeStatusId(challenge.id);
                                        }}
                                    >
                                        Change status
                                    </GreenButton>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
